// All keys referenced for in-memory cache
export const KEYS_GAMES = 'games'
export const KEYS_MODS = 'mods'
export const KEYS_FEATURED = 'featured'
export const KEYS_DISCUSSION = 'discussion'
export const KEYS_GUIDES = 'guides'
export const KEYS_USERS = 'users'
export const KEYS_USERS_STATS = 'users-stats'
